import { useTranslation } from "react-i18next";
import { Link } from "react-router";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="page page-narrow">
      <div className="card">
        <h1 className="section-title">{t("common.notFound")}</h1>
        <Link to="/" className="btn btn-secondary">
          {t("common.home")}
        </Link>
      </div>
    </div>
  );
}
